export const GetDxIcon = () => (
  <svg width={35} height={35} viewBox="0 0 35 35" role="img" aria-label="getDX">
    <rect x={5} y={6} width={25} height={23} rx={4} fill="#151515" />
    <text
      x="17.5"
      y="22"
      textAnchor="middle"
      fill="#fff"
      fontFamily="Arial, Helvetica, sans-serif"
      fontSize={11}
      fontWeight={700}
    >
      DX
    </text>
  </svg>
);
